const stripePaymentLink = process.env.REACT_APP_STRIPE_PAYMENT_LINK;
const sandboxModeValue = process.env.REACT_APP_SANDBOX_MODE;

function isEnabled(value) {
  if (!value) {
    return false;
  }

  return ['1', 'true', 'yes', 'on'].includes(String(value).trim().toLowerCase());
}

if (!stripePaymentLink) {
  throw new Error('Missing REACT_APP_STRIPE_PAYMENT_LINK. Set it in your local env file or deployment environment before running the app.');
}

// White-label configuration for Tripwire landing page
export const WHITE_LABEL_CONFIG = {
  // Brand
  BRAND_NAME: 'EntryMetric',
  BRAND_LEGAL_NAME: 'Entry Metric',
  SUPPORT_EMAIL: 'analysis@entrymetric.co.uk',

  // School / market
  SCHOOL_NAME: 'Bolton School',
  SCHOOL_MONOGRAM: 'BS',
  SCHOOL_DIAGNOSTIC_LABEL: 'Bolton GL-style diagnostic',
  SCHOOL_ENTRANCE_EXAM_LABEL: 'entrance exam',
  SCHOOL_ENTRANCE_EXAM_DATE: '2027-01-15',
  SCHOOL_IMAGE_SRC: '/images/school_2.jpg',
  SCHOOL_IMAGE_ALT: 'Bolton School building',

  BRAND_LOGO_SRC: '/images/EntryMetric-logo.png',
  BRAND_LOGO_LIGHT_SRC: '/images/EntryMetric-light-logo.png',

  // Metadata
  META_TITLE: 'EntryMetric | Bolton School 11+ Diagnostic Pack',
  META_DESCRIPTION: 'EntryMetric Bolton School diagnostic pack with a timed GL-style mock, professional marking, marked answers, and a parent report for 11+ families.',

  FOOTER_TAGLINE: 'Clearer 11+ decisions for Bolton families.',

  // Pricing
  ACTIVE_PRICE: 49,
  ACTIVE_STRIKETHROUGH_PRICE: 79,
  paymentLink: stripePaymentLink,
  isSandboxMode: isEnabled(sandboxModeValue),

  // CTA Texts
  ACTIVE_CTA_TEXT: 'Get My Child\'s Gap Analysis',
};

export const formatPrice = (value) => `£${value}`;

export const getTripwireState = () => ({
  currentPrice: WHITE_LABEL_CONFIG.ACTIVE_PRICE,
  strikethroughPrice: WHITE_LABEL_CONFIG.ACTIVE_STRIKETHROUGH_PRICE,
  formattedCurrentPrice: formatPrice(WHITE_LABEL_CONFIG.ACTIVE_PRICE),
  formattedStrikethroughPrice: WHITE_LABEL_CONFIG.ACTIVE_STRIKETHROUGH_PRICE
    ? formatPrice(WHITE_LABEL_CONFIG.ACTIVE_STRIKETHROUGH_PRICE)
    : null,
  ctaText: WHITE_LABEL_CONFIG.ACTIVE_CTA_TEXT,
  paymentLink: WHITE_LABEL_CONFIG.paymentLink,
});
